export default __webpack_public_path__ + "media/images/elicitbanner/TRUE-TO-LIFE_PHOTOS-IY-compmobile.jpg";